export const processSteps = [
  {
    title: 'Diagnostic',
    period: 'Semaines 1 à 2',
    text: 'Entretiens, analyse des dépenses, revue des contrats et des flux. Je dresse un état des lieux factuel de vos achats et de votre supply chain.',
    deliverables: ['Cartographie des dépenses', 'Points de friction', 'Gisements chiffrés'],
  },
  {
    title: 'Stratégie & feuille de route',
    period: 'Semaines 3 à 4',
    text: 'Je priorise les leviers selon leur impact et leur facilité de mise en œuvre, et nous validons ensemble une feuille de route réaliste.',
    deliverables: ['Stratégies par catégorie', 'Plan d’actions priorisé', 'Business case'],
  },
  {
    title: 'Négociation & sourcing',
    period: 'Mois 2 à 4',
    text: 'Mise en concurrence, consultations, négociations : je conduis les discussions avec vos fournisseurs, aux côtés de vos équipes.',
    deliverables: ['Appels d’offres', 'Contrats renégociés', 'Nouveaux fournisseurs qualifiés'],
  },
  {
    title: 'Déploiement',
    period: 'Mois 3 à 6',
    text: 'Les nouveaux processus, outils et règles de gestion sont mis en place sur le terrain, avec un accompagnement au changement.',
    deliverables: ['Processus documentés', 'Paramétrage des outils', 'Formation des équipes'],
  },
  {
    title: 'Pilotage & transfert',
    period: 'En continu',
    text: 'Je mesure les gains réels, ajuste ce qui doit l’être et transfère les compétences pour que vos équipes deviennent autonomes.',
    deliverables: ['Tableau de bord des gains', 'Revues de performance', 'Transfert de compétences'],
  },
];

export const engagementModels = [
  {
    name: 'Diagnostic express',
    duration: '2 à 3 semaines',
    format: 'Audit flash des dépenses, des contrats et des processus',
    ideal: 'Identifier rapidement vos gisements d’économies',
    deliverable: 'Rapport et plan d’actions priorisé',
  },
  {
    name: 'Mission de transformation',
    duration: '3 à 9 mois',
    format: 'Pilotage d’un ou plusieurs chantiers achats ou supply chain',
    ideal: 'Obtenir des gains durables et structurer la fonction',
    deliverable: 'Gains mesurés, processus et outils déployés',
  },
  {
    name: 'Management de transition',
    duration: '6 à 18 mois',
    format: 'Direction achats ou supply chain par intérim',
    ideal: 'Assurer la continuité et conduire le changement',
    deliverable: 'Équipe structurée, successeur recruté',
  },
  {
    name: 'Accompagnement à la carte',
    duration: 'À la journée',
    format: 'Coaching d’acheteurs, appui sur une négociation clé',
    ideal: 'Renforcer ponctuellement vos équipes',
    deliverable: 'Compétences transférées, négociation conclue',
  },
];
